import AxiosClient from "../../../services/axios.services";

class NotificationSegmentServices {
  getNotificationSegment = (params) =>
    AxiosClient.get(
      "/api/app/notificacion_segmento_correo/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getNotificationSegmentByID = (id) =>
    AxiosClient.get(
      `/api/app/notificacion_segmento_correo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveNotificationSegment = (data) =>
    AxiosClient.post(
      "/api/app/notificacion_segmento_correo/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editNotificationSegment = (id, data) =>
    AxiosClient.put(
      `/api/app/notificacion_segmento_correo/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteNotificationSegment = (id) =>
    AxiosClient.delete(
      `/api/app/notificacion_segmento_correo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new NotificationSegmentServices();
